module.exports = __webpack_public_path__ + "static/media/hamburger-white-on-blue.92e32de0.svg";